<script setup lang="ts">
import { Components } from '@/api/generated/api';
import ThreeDotsActionDialog from '@/core/dialogs/ThreeDotsActionDialog.vue';
import IconButton from '@/core/elements/IconButton.vue';
import ClassOrGroupBadge from '@/core/elements/ClassOrGroupBadge.vue';
import { EIcon } from 'common/enum/misc.enum';
import { getClassName } from 'common/utils/format.utils';

const emit = defineEmits<{
  'click:remove': [];
  'click:split': [];
  'click:add': [];
}>();

defineProps<{
  studentCount: number;
  schoolClass: Components.Schemas.SchoolClassDto;
  type: 'remove' | 'add';
  disabled?: boolean;
  surface?: 'primary' | 'secondary';
}>();
</script>

<template>
  <li
    class="list-item-base rounded-md gap-md"
    :class="surface === 'primary' ? 'bg-surface-primary' : 'bg-surface-secondary'"
  >
    <ClassOrGroupBadge :school-class="schoolClass" class="!size-button shrink-0" />
    <div class="flex flex-col flex-grow min-w-0">
      <div class="w-full font-semibold truncate">
        {{ getClassName(schoolClass) }}
      </div>
      <div class="text-muted truncate">
        {{ $t('general.studentCount', { count: studentCount }) }}
      </div>
    </div>
    <ThreeDotsActionDialog
      v-if="type !== 'add' && !disabled"
      class="shrink-0"
      :actions="[
        {
          label: $t('accessRights.splitStudentsEntry'),
          action: () => emit('click:split'),
          separatorAfter: true,
        },
        {
          label: $t('general.delete'),
          style: 'error',
          action: () => emit('click:remove'),
        },
      ]"
    />
    <IconButton
      v-if="type === 'add' && !disabled"
      :icon-name="EIcon.PLUS"
      theme="primary-filled"
      class="h-button w-button shrink-0"
      @click="emit('click:add')"
    />
    <IconButton
      v-if="type === 'remove' && !disabled"
      :icon-name="EIcon.X"
      theme="secondary"
      class="size-button shrink-0"
      @click="emit('click:remove')"
    />
  </li>
</template>
